const defaultTheme = {
  // menu style
  menuItem_BG: '#fff', // white
  menuItemSelected_BG: '#d84c4c', // red
  menuItem_text: "#000", // black
  menuItemSelected_text: "#fff", // white
  dropdownSelect_BG: '#fff', // white
  dropdownOption_BG: '#fff', // white
  dropdownSelect_text: '#000', // black
  dropdownOption_text: '#000', // black

  // gameWeek style
  gameWeek_border: '#bfbfbf', //grey
  gameWeekSelected_border: '#d84c4c', // red
  gamwWeek_text: '#000', //black
  gameWeek_timer_bg: '#d84c4c', // red
  gameWeel_live_bg: '#f9eb38', // yellow
  gameWeel_live_text: '#000', //back

  // superOdds style
  superOdds_heading_BG: '#242d72', // blue
  superOdds_heading_text: '#fff', // white
  superOdds_BG: '#e6e6e6', // light
  superOdds_text: '#000', //black
  superOddSelected_BG: '#d84c4c', // red
  superOddSelected_text: '#fff', //white
  superOddsTableHeading_BG: '#242d72', //blue
  superOddsTableHeading_text: '#fff', //white
  superOddsSplide__pagination: '#d84c4c', // red

  // markets style
  markets_BG: '#fff', // white
  markets_border: '#e6e6e6', //light
  marketsSelected_border: '#d84c4c', // red
  marketsSelected_BG: '#d84c4c', // red
  markets_text: '#000', //black
  marketsSelected_text: '#fff', //white

  // game table style
  gamesTableHeading_BG: '#242d72', //blue
  gamesTableHeading_text: '#fff', //white
  gameOdds_BG: '#e6e6e6', // light
  gameOdds_text: '#000', //black
  gameOddsSelected_BG: '#d84c4c', // red
  gameOddsSelected_text: '#fff', //white

  // footer style
  footerOdds_BG: '#242d72', //blue
  footerOdds_text: '#fff', //white
  footerBonus_BG: '#d84c4c', // red
  footerBonus_text: '#fff', //white
  betslipBtn_BG: '#fff', //white
  betslipBtn_text: '#d84c4c', // red
  betslipBtn_border: '#d84c4c', // red
  betslipBtnSelected_BG: '#d84c4c', // red
  betslipBtnSelected_text: '#fff', //white
  betslipBtnSelected_border: '#d84c4c', // red
  betslipBtnCount_BG: '#fff', //white
  betslipBtnCount_text: '#d84c4c', // red
  betslipBtnCount_border: '#d84c4c', // red
  betslipBtnCountSelected_BG: '#fff', //white
  betslipBtnCountSelected_text: '#d84c4c', // red
  betslipBtnCountSelected_border: '#d84c4c', // red

  // live style
  liveHead_BG: '#242d72', //blue
  liveHead_text: '#fff', //white
  liveTimer_BG: '#d84c4c', // red
  liveTimer_text: '#fff', // white
  liveFT_text: '#fff', // white
  liveHeading_BG: '#f9eb38', // yellow
  liveHeading_text: '#000', // black

  // points table style
  pointsTableHead_BG: '#242d72', //blue
  pointsTableHead_text: '#fff', // white

  // retult style
  resultHead_BG: '#242d72', //blue
  resultHead_text: '#fff', // white
  retultFT_text: '#fff', //white

  // betslip style
  betslipHead_BG: '#242d72', //blue
  betslipHead_text: '#fff', // white
  betslipCount_BG: '#d84c4c', // red
  betslipCount_text: '#fff', // white
  betslipOdds_text: '#d84c4c', // red
  betslipBonus_BG: '#e7eafe', // info 
  betslipBonus_text: '#d84c4c', // red
  betslipStakeBtn_BG: '#e7eafe', // info
  betslipStakeBtnSelected_BG: '#d84c4c', // red
  betslipStakeBtn_text: '#000', // black
  betslipStakeBtnSelected_text: '#fff', // white
  betslipStakeBtn_border: '#e7eafe', // info
  betslipStakeBtnSelected_border: '#d84c4c', // red
  betslipPlaceBet_BG: '#d84c4c', // red
  betslipPlaceBet_text: '#fff', // white
  betslipPlaceBet_border: '#d84c4c', // red
  modalBtn_BG: '#d84c4c', // red
  modalBtn_text: '#fff', //white
  signleDeleteIcon: '#999', // grey

  beslip_modal_bg: '#fff', //white

  // betHistory style
  historyHead_BG: '#242d72', //blue
  historyHead_text: '#fff', // white
  historyBottom_BG: '#e7eafe', // info
  historyBottom_text: '#000', // black

  openStatus_bg: '#f9eb38', // yellow

  // loader style
  loader_text: '#242d72', //blue
};

const betcorrectTheme = {
  // menu style
  menuItem_BG: '#fff', // white
  menuItemSelected_BG: '#f47621', // orange
  menuItem_text: "#000", // black
  menuItemSelected_text: "#fff", // white
  dropdownSelect_BG: '#e6e6e6', // light
  dropdownOption_BG: '#fff', // white
  dropdownSelect_text: '#000', // black
  dropdownOption_text: '#000', // black

  // gameWeek style
  gameWeek_border: '#bfbfbf', //greay
  gameWeekSelected_border: '#f47621', //orange
  gamwWeek_text: '#000',  // black
  gameWeek_timer_bg: '#28A95B', //green
  gameWeel_live_bg: '#f9eb38', // yellow
  gameWeel_live_text: '#000', //back

  // superOdds style
  superOdds_heading_BG: '#f47621', // orange
  superOdds_heading_text: '#fff', // white
  superOdds_BG: '#e6e6e6', // light
  superOdds_text: '#000', //black
  superOddSelected_BG: '#28A95B', // green
  superOddSelected_text: '#fff', //white
  superOddsTableHeading_BG: '#ffe7d3', //light orange
  superOddsTableHeading_text: '#000', //black
  superOddsSplide__pagination: '#f47621', //orange

  // markets style
  markets_BG: '#e6e6e6', //light
  markets_border: '#e6e6e6', //light
  marketsSelected_border: '#f47621', //orange
  marketsSelected_BG: '#fff', // white
  markets_text: '#000', //black
  marketsSelected_text: '#f47621', //orange

  // game table style
  gamesTableHeading_BG: '#ffe7d3', //light orange
  gamesTableHeading_text: '#000', //black
  gameOdds_BG: '#e6e6e6', // light
  gameOdds_text: '#000', //black
  gameOddsSelected_BG: '#28A95B', // green
  gameOddsSelected_text: '#fff', //white

  // footer style
  footerOdds_BG: '#28A95B', // green
  footerOdds_text: '#fff', //white
  footerBonus_BG: '#e6e6e6', // light
  footerBonus_text: '#f47621', //orange
  betslipBtn_BG: '#fff', //white
  betslipBtn_text: '#f47621', //orange
  betslipBtn_border: '#f47621', //orange
  betslipBtnSelected_BG: '#f47621', //orange
  betslipBtnSelected_text: '#fff', //white
  betslipBtnSelected_border: '#f47621', //orange
  betslipBtnCount_BG: '#fff', //white
  betslipBtnCount_text: '#f47621', //orange
  betslipBtnCount_border: '#f47621', //orange
  betslipBtnCountSelected_BG: '#28A95B', // green
  betslipBtnCountSelected_text: '#fff', //white
  betslipBtnCountSelected_border: '#28A95B', // green

  // live style
  liveHead_BG: '#ffe7d3', //light orange
  liveHead_text: '#000', //black
  liveTimer_BG: '#28A95B', // green
  liveTimer_text: '#fff', // white
  liveFT_text: '#000', // white
  liveHeading_BG: '#f9eb38', // yellow
  liveHeading_text: '#000', // black

  // points table
  pointsTableHead_BG: '#f47621', //orange
  pointsTableHead_text: '#fff', // white

  // retult style
  resultHead_BG: '#ffe7d3', //light orange
  resultHead_text: '#000', // black
  retultFT_text: '#000', //black

  // betslip style
  betslipHead_BG: '#f47621', //orange
  betslipHead_text: '#fff', // white
  betslipCount_BG: '#28A95B', // green
  betslipCount_text: '#fff', // white
  betslipOdds_text: '#f47621', //orange
  betslipBonus_BG: '#e6e6e6', // light
  betslipBonus_text: '#f47621', //orange
  betslipStakeBtn_BG: '#e6e6e6', // light
  betslipStakeBtnSelected_BG: '#28A95B', // green
  betslipStakeBtn_text: '#f47621', //orange
  betslipStakeBtnSelected_text: '#fff', // white
  betslipStakeBtn_border: '#e6e6e6', // light
  betslipStakeBtnSelected_border: '#28A95B', // green
  betslipPlaceBet_BG: '#28A95B', // green
  betslipPlaceBet_text: '#fff', // white
  betslipPlaceBet_border: '#28A95B', // green
  modalBtn_BG: '#28A95B', // green
  modalBtn_text: '#fff', //white
  signleDeleteIcon: '#f47621', //orange

  beslip_modal_bg: '#fff', //white

  // betHistory style
  historyHead_BG: '#ffe7d3', //light orange
  historyHead_text: '#000', // black
  historyBottom_BG: '#e6e6e6', // light
  historyBottom_text: '#000', // black

  openStatus_bg: '#F5C330', // yellow

  // loader style
  loader_text: '#f47621', //orange
};

export const getTheme = (operatorId) => {
  // debugger;
  switch (operatorId) {
    case 'betcorrect':
      return betcorrectTheme;
    default:
      return defaultTheme
  }

}